import { useState, useEffect } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import { setTabOnFocus } from '../../store/global/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getTabOnFocus } from '../../store/global/selectors';
import { Grid } from '@material-ui/core';
import Page from '../atoms/page';
import { getDetailsFromUrl } from '../../services/blueprint';
import BuildDeployLogs from '../molecules/blueprint/BuildDeployLogs';
import BuildOutput from './BuildOutput';
import Tooltip from '@material-ui/core/Tooltip';


export default function BlueprintBuildTabs(props) {
    const browserTabTitle =  props?.browserTabTitle;
    const logType = props?.logType;
    const dispatch = useDispatch();
    const tabOnFocus = useSelector(getTabOnFocus);
    const [openTab, setOpenTab] = useState(0);
    const [isRecentBatch, setIsRecentBatch] = useState(true);

    
    const { blueprintId } = getDetailsFromUrl();

    useEffect(() => {
        setOpenTab(tabOnFocus);
    }, [tabOnFocus])


    // useEffect(() => {
    //     dispatch(triggerTour({currentTour: 'configurations'}))
    // },[])

    return (
        <Page title={browserTabTitle !== undefined ? browserTabTitle : "Build Logs"} style={{ marginTop123: "-64px" }} padding ={"0px"}>
            <Grid container direction={"row"}>
                <AppBar position="static">
                    <Tabs value={openTab} onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }} aria-label="ConfigurationTabs">
                        <Tab label={logType === "build" ? "Build History" : "Deploy History"} id="build_history_tab" data-ui-tour-id="build_history_tab" style={{textTransform: 'capitalize'}} title={"View Build Logs"}/>
                        {isRecentBatch ? <Tab label="Build Output" id="build_output_tab" data-ui-tour-id="build_output_tab" style={{textTransform: 'capitalize'}} disabled={!isRecentBatch} title={"View Build Files"}/>                     
                            :
                            <Tooltip title="Only Recent Build can be viewed" arrow>
                                <span>
                                    <Tab label="Build Output" id="build_output_tab" data-ui-tour-id="build_output_tab" style={{textTransform: 'capitalize'}} disabled={!isRecentBatch} title={"View Build Files"}/> 
                                </span>
                            </Tooltip>                          
                        }
                    </Tabs>
                </AppBar>


                <TabPanel value={openTab} index={0} style={{width: '100%'}}>
                    <BuildDeployLogs  logType={logType}  setIsRecentBatch={setIsRecentBatch}/>
                </TabPanel>

                <TabPanel value={openTab} index={1} style={{width: '100%'}}>
                   <BuildOutput />
                </TabPanel>            

            </Grid>
        </Page>
    )
}